<template>
  <div class="ct-image-citation-show-on-page">
    <slot />

    <div
      v-if="citations"
      class="ct-image-citation-show-on-page__container"
    >
      <div
        class="ct-image-citation-show-on-page__text"
        :class="{
          'ct-image-citation-show-on-page__text--white':makeTextWhite
        }"
        v-html="citations"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
	citations: string | undefined
	makeTextWhite: boolean
}>()
</script>

<style lang="postcss" scoped>
@reference '#importtailwindcss';

.ct-image-citation-show-on-page{
@apply flex flex-col justify-between gap-3;

&__container{
    @apply flex justify-end;
}

    &__text{
        @apply custom-font__small-text-2;

        &--white{
            @apply text-white;
        }
    }

}
</style>
